module.exports = "/**\n* Import the colors and spacers from cf-design\n*/\n.header-icon {\n  font-size: 80px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/update-profile/confirm-phone-number/confirm-phone-number.component.scss
// module id = ./src/app/shared/update-profile/confirm-phone-number/confirm-phone-number.component.scss
// module chunks = main